import { Flip, Slide, ToastContainerProps } from 'react-toastify'

/**
 * Default toast options.
 * Use these options to ensure consistency across the application.
 */
export const toastDefaultOptions: ToastContainerProps = {
  hideProgressBar: true,
  transition: Slide,
  position: 'top-center',
  pauseOnFocusLoss: false,
  containerId: 'global', // This is the default container id
}

/**
 * ToastContainer options for the feedback loop.
 */
export const feedbackLoopToastContainerProps: ToastContainerProps = {
  autoClose: 1600,
  closeButton: false,
  closeOnClick: true,
  hideProgressBar: true,
  position: 'bottom-center',
  transition: Flip,
  icon: false,
  limit: 1,
  className: () => '-bottom-4 w-96 mx-auto',
  toastClassName: ({ type }) => {
    const classes = 'max-h-6 text-xs shadow rounded text-center bg-white font-semibold px-3'
    if (type === 'success') {
      return `${classes} text-green-600`
    }
    if (type === 'error') {
      return `${classes} text-red-600`
    }
    return classes
  },
}

/**
 * ToastContainer options for the login feedback.
 */
export const loginFeedbackToastProps: ToastContainerProps = {
  autoClose: 2000,
  closeButton: false,
  hideProgressBar: true,
  icon: false,
  limit: 1,
  toastClassName: ({ type }) => {
    const classes = 'text-center bg-transparent font-semibold px-3 py-3'
    if (type === 'success') {
      return `${classes} text-green-600`
    }
    if (type === 'error') {
      return `${classes} text-red-600`
    }
    return classes
  },
}
